import { DropdownComponentProps } from "@/app/interface/components"
import React, { useState } from "react"
import styles from "@/styles/DropdownComponent.module.scss"

const DropdownComponent: React.FC<DropdownComponentProps> = ({ title, text, isOpen, onToggle }) => {
  return (
      <div className={styles.main}>
          <button type="button" onClick={onToggle}>
              {title} <span className={`AZUL-AGRO${isOpen ? ' rotate' : ''}`}>b</span>
          </button>
          <p className={isOpen ? ' ' + styles.show : ''}>{text}</p>
      </div>
  )
}

export default React.memo(DropdownComponent)
  